import { memo, useContext, createContext, useMemo } from 'react';
import { jsx } from 'react/jsx-runtime';

/* External */
var SliderValueContext = /*#__PURE__*/createContext(0);
var SliderConfigContext = /*#__PURE__*/createContext({
  vertical: false,
  minValue: 0,
  maxValue: 0
});
function SliderProviderComponent(_ref) {
  var value = _ref.value,
    vertical = _ref.vertical,
    children = _ref.children,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    flat = _ref.flat;
  var config = useMemo(function () {
    return {
      vertical: vertical,
      minValue: minValue,
      maxValue: maxValue,
      flat: flat
    };
  }, [vertical, minValue, maxValue, flat]);
  return /*#__PURE__*/jsx(SliderConfigContext.Provider, {
    value: config,
    children: /*#__PURE__*/jsx(SliderValueContext.Provider, {
      value: value,
      children: children
    })
  });
}
SliderProviderComponent.defaultProps = {
  vertical: false,
  flat: false,
  children: null
};
var SliderProvider = /*#__PURE__*/memo(SliderProviderComponent);
function useSliderValue() {
  return useContext(SliderValueContext);
}
function useSliderConfig() {
  return useContext(SliderConfigContext);
}

export { SliderProvider, useSliderConfig, useSliderValue };
//# sourceMappingURL=SliderContext.js.map
